import React from 'react';
import { withStyles,
  FormControl,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment} from '@material-ui/core';
import Utils from '../../share/Utils';
import MensalidadeService from '../../../services/MensalidadeService';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import { inject, observer } from 'mobx-react';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit * 2,
    minWidth: 230,
  },
  flex: {
    display: 'flex',
  },
});
@inject('usuarioStore')
@observer
class FormDialogMensalidade extends React.Component {
  utils = new Utils();
  mensalidadeService = new MensalidadeService();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.mensalidade,
      errorMessageValorIndice: '',
      errorMessageValorSeguro: '',
      valorIndice: '0,00',
      valores: [],
      fetching: false,
      valorSeguroNovo: this.utils.formataValor(this.props.valorSeguro),
    };
  }
componentDidMount = async () => {
  this.setState({fetching: true});
  await this.consultarValoresMensalidade();
  this.setState({fetching: false});
}
consultarValoresMensalidade = async () => {
  let valores = await this.mensalidadeService.consultarValoresMensalidade(this.props.ultimaMensalidade, 'N');
  this.setState({valores: valores});
}
  handleClickSave = async () => {
    const reajuste = {
      valorIndice: Number(this.state.valorIndice.replace('.', '').replace('.', '').replace(',', '.')),
      isFolhaFechada: this.props.isFolhaFechada,
      valorSeguro: Number(this.state.valorSeguroNovo.replace('.', '').replace('.', '').replace(',', '.')),
      codUsuarioCadastro: this.props.usuarioStore.codigoUsuario,
      valorSeguroAntigo: this.props.valorSeguro,
    };
    await this.props.handleSave(reajuste);
  }
  handleChangeTextFieldIndice = event => {
    var valorNovo = '';
    valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value.substring(0, 6), event.target.defaultValue) : '';
    this.setState({ [event.target.name]: valorNovo, errorMessageValorIndice: '' });
  };
  handleChangeTextFieldSeguro = event => {
    var valorNovo = '';
    valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value.substring(0, 6), event.target.defaultValue) : '';
    this.setState({ [event.target.name]: valorNovo, errorMessageValorSeguro: '' });
  };
  handleBlurValorIndice = event => {
    if (this.state.valorIndice === '' || this.state.valorIndice === null || this.state.valorIndice === undefined) {
      this.setState({errorMessageValorIndice: 'Favor preencher o índice'});
    } else {
      this.setState({errorMessageValorIndice: ''});
    }
  }
  handleBlurValorSeguro = event => {
    if (this.state.valorSeguroNovo === '' || this.state.valorSeguroNovo === null || this.state.valorSeguroNovo === undefined) {
      this.setState({errorMessageValorSeguro: 'Favor preencher o seguro'});
    } else {
      this.setState({errorMessageValorSeguro: ''});
    }
  }
  isSalvarDisabled = () => {
    return (this.state.errorMessageValorIndice !== '' ||
    this.state.valorIndice === undefined ||
    this.state.valorIndice === '' ||
    this.state.valorIndice === 0 ||
    this.state.valorIndice === '0,00') ||
    (this.state.errorMessageValorSeguro !== '' ||
    this.state.valorSeguroNovo === undefined ||
    this.state.valorSeguroNovo === '' ||
    this.state.valorSeguroNovo === 0 ||
    this.state.valorSeguroNovo === '0,00');
  }
  select = event => {
    event.target.select();
  }
  render () {
    const { classes, open, handleClose, titulo, valorSeguro } = this.props;
    const { valores, fetching } = this.state;
    const proximaMensalidade = this.props.ultimaMensalidade + 1;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='sm'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{titulo}</DialogTitle>
          {fetching ? <LinearProgressBlockScreen />
            : <div>
              <DialogContent>
                <FormControl className={classes.formControl}>
                  <TextField
                    autoFocus
                    onFocus={this.select}
                    value={this.state.valorIndice === undefined ? '0,00' : this.state.valorIndice}
                    margin='dense'
                    id='valorIndice'
                    name='valorIndice'
                    error={this.state.errorMessageValorIndice !== ''}
                    label={this.state.errorMessageValorIndice !== '' ? this.state.errorMessageValorIndice : 'Índice %'}
                    fullWidth
                    onChange={this.handleChangeTextFieldIndice}
                    onBlur={this.handleBlurValorIndice}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    value={this.state.valorSeguroNovo === null || this.state.valorSeguroNovo === undefined ? '0,00' : this.utils.formataValor(this.state.valorSeguroNovo)}
                    margin='dense'
                    id='valorSeguroNovo'
                    name='valorSeguroNovo'
                    error={this.state.errorMessageValorSeguro !== ''}
                    label={this.state.errorMessageValorSeguro !== '' ? this.state.errorMessageValorSeguro : 'Valor Seguro'}
                    fullWidth
                    onChange={this.handleChangeTextFieldSeguro}
                    onBlur={this.handleBlurValorSeguro}
                    InputProps={{
                      startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                    }}
                  />
                </FormControl>
                <Typography> {'* A mensalidade de sequencial ' + this.props.ultimaMensalidade + ' será encerrada com a data atual e será criada a nova mensalidade com o sequencial ' + proximaMensalidade}</Typography>
                <Typography>{'** O valor do seguro para o reajuste anterior (sequencial ' + this.props.ultimaMensalidade + ') era de ' + new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(valorSeguro)}</Typography>
                <Typography>{'*** Serão gerados ' + valores.length + ' registro(s) no novo reajuste '}</Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color='primary' id={'fechar'}>
                  Fechar
                </Button>
                <Button
                  disabled={this.isSalvarDisabled()}
                  onClick={this.handleClickSave}
                  color='primary'>
                  Gerar Reajuste
                </Button>
              </DialogActions>
            </div>}
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogMensalidade);
